//./LeadDetailCard.js
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../../../components/ui/card";

export const LeadDetailCard = ({ title, details }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {details.map((item, index) => (
          <div key={index} className="flex items-start text-sm">
            <item.icon className="w-4 h-4 mt-0.5 mr-3 text-muted-foreground" />
            <div className="flex-1">
              <p className="font-semibold text-gray-600">{item.label}</p>
              <div className="text-gray-800">{item.value}</div>
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};
